export const PAGE_STORE = 'page'
